var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoHome24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_home24x24",
    transform: "translate(-1.9 -4.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(1.9 4.2)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M8.1,2.4,1.8,7.894h0v5.587a.778.778,0,0,0,.7.745H6.7V9.757H9.5v4.47h4.2a.778.778,0,0,0,.7-.745V7.8Z",
    transform: "translate(.9 .774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M16.722,6.463,14.316,4.322V-.428A.392.392,0,0,0,13.959-.8H11.821a.392.392,0,0,0-.356.372h0V1.807L8.791-.521a1.561,1.561,0,0,0-1.782,0l-8.02,6.984A.3.3,0,0,1-1.1,6.65a.352.352,0,0,0,.089.279l.713.838c.089.093.178.186.267.186A.318.318,0,0,0,.237,7.86L7.9,1.156l7.663,6.7a.318.318,0,0,0,.267.093h0c.089,0,.178-.093.267-.093l.713-.931A.352.352,0,0,0,16.9,6.65C16.811,6.557,16.811,6.463,16.722,6.463Z",
    transform: "translate(1.1 .8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoHome24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_home24x24.6255fbeb4836e9e8e34604d642f2d99f.svg";